(function() {
	if (typeof(orderNum) != 'undefined') {
		var re = re = RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
		var email = $("#ys_billToEmail").text();
		var sa = $("#ys_shipToAddress .ys_csz").text().match( /([^,]+),\s*(\w{2})\s*(\d{5}(?:-\d{4})?)/ )
		var ba = $("#ys_billToAddress .ys_csz").text().match( /([^,]+),\s*(\w{2})\s*(\d{5}(?:-\d{4})?)/ )

		window.analytics.identify(email.match(re)[0], {
		  name: jQuery("#ys_shipToAddress .ys_name").text(),
		  firstName: jQuery("#ys_shipToAddress .ys_name").text(),
		  lastName: jQuery("#ys_shipToAddress .ys_name").text(),
		  email: email.match(re)[0],
		  shippingAddress: {  // uses the default address
			street: jQuery("#ys_shipToAddress .ys_address1").text(),
			city: sa[1],
			state: sa[2],
			postalCode: sa[3],
			country: "US",
		  },
		  billingAddress: {  // uses the default address
			street: jQuery("#ys_billToAddress .ys_address1").text(),
			city: ba[1],
			state: ba[2],
			postalCode: ba[3],
			country: "US",
		  },
		}, {wcapiVersion: '1.0'});
	}
})();
